import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Space,
  Input,
  Form,
  Radio,
  Select,
  message,
  notification,
  InputNumber,
  Col,
  Row,
} from "antd";
import { Table } from "antd";
import { SearchOutlined, EditFilled } from "@ant-design/icons";
import "../css/product.css";
import axios from "axios";
import { path, src } from "../network/conn";
const key = "updatable";
const openMessageLoading = (load) => {
  message.loading({ content: load, key });
};
const openMessageSuccess = (loaded) => {
  message.success({ content: loaded, key, duration: 2 });
};

const Masteremployee = (props) => {
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [dataSource, setdataSource] = useState([]);
  const [size, setSize] = useState();
  const [totalRecord, settotalRecord] = useState(0);
  const [customerType, setcustomerType] = useState("direct");
  const [submitType, setsubmitType] = useState("insert");
  const [profileList,setProfileList] = useState([]);
  const [userSetting,setUserSetting] = useState({});
  const [form] = Form.useForm();
  const logUser = window.sessionStorage.getItem("user");
  const addProduct = () => {
    setsubmitType("insert");
    fetchCount();
    showLargeDrawer();
  };
  const showLargeDrawer = () => {
    setSize("large");
    setVisible(true);
  };
  const drawerClose = () => {
    setVisible(false);
    form.resetFields();
  };
  const { Option } = Select;
  const fetchcustomerType = (e) => {
    setcustomerType(e.target.value);
  };

  const onFinish = (e) => {
    const data = e;
    data['user'] = logUser;
    openMessageLoading("Adding Employee", 20);
    let BaseURL = path + src + "insertemployee.php";
    axios
      .post(BaseURL, data)
      .then((response) => {
        openMessageSuccess(response.data, 20);
        setVisible(false);
        drawerClose();
        fetchTableData();
        form.resetFields();
      })
      .catch((error) => {
        openMessageSuccess(error, 10);
      });
  };
  const fetchTableData = () => {
    setLoading(true);
    let BaseURL = path + src + "employeelist.php";
    axios
      .get(BaseURL)
      .then((response) => {
        let filteredArr = response.data.sort((a,b)=>{return b.id - a.id});
        setdataSource(filteredArr);
        settotalRecord(response.data.length);
        setVisible(false);
        setLoading(false);
      })
      .catch((error) => {
        openMessageSuccess(error, 10);
      });
  };
  const fetchPincode = (e) => {
    let pincode = e.target.value;
    let BaseURL = path + src + "pincode.php?pincode=" + pincode;
    axios
      .get(BaseURL)
      .then((response) => {
        form.setFieldsValue({
          district: response.data.district,
          state: response.data.state,
        });
      })
      .catch((error) => {
        openMessageSuccess(error, 10);
      });
  };
  const fetchProfile = (e) => {
    let BaseURL = path + src + "profilelist.php";
    axios
      .get(BaseURL)
      .then((response) => {
      setProfileList(response.data);
      })
      .catch((error) => {
        openMessageSuccess(error, 10);
      });
  };
  const fetchCount = () => {
        let value = dataSource.length + 1 ; 
        let valueStr = "0000"+ value.toString();
        settotalRecord(dataSource.length);
        form.setFieldsValue({
          employeecode: "EMP-" + (valueStr.substr(-4)),
          submit: "insert",
        });
  };
  const onEditProduct = (record) => {
    setsubmitType("update");
    console.log(submitType);
    showLargeDrawer();
    let response = dataSource.filter((list)=>{return list.employeecode == record.employeecode});
    console.log(response[0]);
      form.setFieldsValue({
        employeecode: record.employeecode,
        employeename: response[0].employeename,
        mobile: response[0].mobile,
        email: response[0].email,
        pincode: response[0].pincode,
        address: response[0].street,
        district: response[0].district,
        state: response[0].state,
        status: response[0].statusid,
        username: response[0].username,
        password: response[0].password,
        basicpay: response[0].basicpay,
        usertype: response[0].usertype,
        proof: response[0].idproof,
        address: response[0].address,
        date  : response[0].date,
        time : response[0].time,
        submit: "update",
      });
  };
  const profile = window.sessionStorage.getItem("profile");
  const fetch_profile_permission = (profile) =>{
    console.log('profile',profile);
    let BaseURL = path + src + "fetch_profile_permission.php?profile="+profile;
    axios
    .get(BaseURL)
      .then((response) => {
        console.log(response.data);
        let dataObj = {};
        response.data.map((list)=>{
          let permissionObj = {};
          if(list.filename == 'masteremployee'){
          permissionObj['add']      = list.add;
          permissionObj['edit']     = list.edit;
          permissionObj['delete']   = list.delete;
          permissionObj['show']     = list.show;
          permissionObj['print']    = list.print;
          permissionObj['excel']    = list.excel;
          permissionObj['profile']  = list.profile;
          dataObj[list.filename]    =  permissionObj;
          setUserSetting(permissionObj);
          }
        })
       
       console.log('dataObj',dataObj);
      })
      .catch((error) => {
        //openMessageSuccess(error, 10);
        console.log(error);
      });
    }
  useEffect(() => {
    fetch_profile_permission(profile);
    fetchTableData();
    fetchProfile();
  }, []);
  const columns = [
    {
      key: "1",
      title: "Sno",
      dataIndex: "id",
      sorter: (record1, record2) => {
        return record1.id > record2.id;
      },
    },
    {
      key: "2",
      title: "Employee Id",
      dataIndex: "employeecode",
    },

    {
      key: "3",
      title: "Employee Name",
      dataIndex: "employeename",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              autocomplete="off"
              placeholder="Type To Search"
              autoFocus
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm({ closeDropdown: false });
              }}
            ></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.name.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      key: "3",
      title: "Mobile",
      dataIndex: "mobile",
    },
    {
      key: "4",
      title: "Status",
      dataIndex: "statusid",
    },
    {
      key: "5",
      title: "Edit",
      render: (record) => (
       Number(userSetting.edit == 1) ?  <Button
          title="Edit"
          size="small"
          type="primary"
          onClick={() => {
            onEditProduct(record);
          }}
        >
          <EditFilled />
        </Button> : ''
      ),
    },
    // {
    //   key: "8",
    //   title: "Delete",
    //   render: (record) => (
    //     <Button
    //       title="Edit"
    //       size="small"
    //       type="danger"
    //       onClick={() => {
    //         openNotification(record);
    //       }}
    //     >
    //       Delete
    //     </Button>
    //   ),
    // },
  ];
  return (
    <>
      <Space>
        { Number(userSetting.add) == 1 ? <Button type="primary" onClick={addProduct}>
          Add Employee +
        </Button> : ''}
      </Space>
      <Modal
        title={submitType == "insert" ? "Add Employee" : "Edit Employee"}
        style={{ top: 20 }}
        visible={visible}
        onOk={() => drawerClose()}
        onCancel={() => drawerClose()}
        width={1000}
        maskClosable={false}
        footer={null}
      >
        <Form layout="vertical" form={form} onFinish={onFinish}>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                name="employeecode"
                label="Employeecode"
                //rules={[{ required: true, message: "Please enter user name" }]}
              >
                <Input autocomplete="off" placeholder="Please Employee code" />
              </Form.Item>
            </Col>
            {/* <Col span={12}>
              <Form.Item
                name="usertype"
                label="Usertype"
                rules={[{ required: true, message: "Please enter Usertype" }]}
              >
                <Radio.Group>
                  <Radio value="admin">Administrator</Radio>
                  <Radio value="user">User</Radio>
                </Radio.Group>
              </Form.Item>
            </Col> */}
            <Col span={12}>
              <Form.Item
                name="usertype"
                label="Usertype"
                rules={[{ required: true, message: "Please enter Usertype" }]}
              >
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  autocomplete="off"
                  placeholder="Select Profile"
                >
                 {profileList.map((list=>
                   <Option value={list.code}>{list.profile}</Option>
                  ))}
                 
                </Select>
              </Form.Item>
            </Col> 
          </Row>

          <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                name="employeename"
                label="Employeename"
                rules={[
                  { required: true, message: "Please enter Employeename" },
                ]}
              >
                <Input
                  autocomplete="off"
                  placeholder="Please Company EmployeeName"
                />
              </Form.Item>
              <Form.Item
                name="date"
                label="Name"
                style={{display:"none"}}
                rules={[{ required: false, message: "Please enter Name" }]}
              >
                <Input autocomplete="off" placeholder="Please Customer Name" />
              </Form.Item>
              <Form.Item
                name="time"
                label="Name"
                style={{display:"none"}}
                rules={[{ required: false, message: "Please enter Name" }]}
              >
                <Input autocomplete="off" placeholder="Please Customer Name" />
              </Form.Item>
              <Form.Item
                name="submit"
                label="sumit"
                value={submitType}
                rules={[{ required: false }]}
                hidden={true}
              >
                <Input placeholder="Submit" autocomplete="off" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="status"
                label="Status"
                rules={[{ required: true, message: "Please enter Opening" }]}
              >
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  autocomplete="off"
                  placeholder="Select Status"
                >
                  <Option value="active">Active</Option>
                  <Option value="inactive">InActive</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                name="username"
                label="Username"
                rules={[{ required: true, message: "Please enter username" }]}
              >
                <Input
                  autocomplete="off"
                  placeholder="Please Enter Username"
                ></Input>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="password"
                label="Password"
                rules={[{ required: true, message: "Please enter Password" }]}
              >
                <Input
                  autocomplete="off"
                  placeholder="Please Enter password"
                ></Input>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                name="mobile"
                label="Mobile"
                rules={[
                  { required: true, message: "Please enter Mobile" },
                  { min: 10, message: "Enter Valid Moile Number" },
                ]}
              >
                <Input
                  autocomplete="off"
                  placeholder="Please Enter Moile"
                ></Input>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="email"
                label="Email"
                //rules={[{ required: true, message: "Please enter user name" }]}
              >
                <Input
                  autocomplete="off"
                  placeholder="Please Enter Email"
                ></Input>
              </Form.Item>
            </Col>
          </Row>

          {/* <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                name="basicpay"
                label="Basicpay"
                rules={[{ required: false, message: "Please enter basic" }]}
              >
                <Input
                  autocomplete="off"
                  placeholder="Please Enter basic"
                ></Input>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="proof"
                label="Proof"
                rules={[{ required: false, message: "Please enter Proof" }]}
              >
                <Input
                  autocomplete="off"
                  placeholder="Please Enter Proof"
                ></Input>
              </Form.Item>
            </Col>
          </Row> */}
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                name="pincode"
                label="Pincode"
                rules={[{ required: true, message: "Please enter Pincode" }]}
              >
                <Input
                  autocomplete="off"
                  placeholder="Please Enter Pincode"
                  onChange={fetchPincode}
                ></Input>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="address"
                label="Address"
                rules={[{ required: true, message: "Please enter Address" }]}
              >
                <Input
                  autocomplete="off"
                  placeholder="Please Enter Address"
                ></Input>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                name="district"
                label="District"
                rules={[{ required: true, message: "Please enter District" }]}
              >
                <Input
                  autocomplete="off"
                  placeholder="Please Enter District"
                ></Input>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="state"
                label="State"
                rules={[{ required: true, message: "Please enter State" }]}
              >
                <Input
                  autocomplete="off"
                  placeholder="Please Enter State"
                ></Input>
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              {submitType == "insert" ? "Submit" : "Update"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <Table
        bordered
        className="tableData"
        dataSource={dataSource}
        columns={columns}
        loading={loading}
        pagination={{ pageSize: 5, total: { totalRecord } }}
      ></Table>
    </>
  );
};
export default Masteremployee;
